import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileCTA } from "@/components/site/MobileCTA";
import { Loader } from "@/components/site/Loader";
import { ScrollProgress } from "@/components/site/Animations";

import Home from "@/pages/Home";
import Dispatch from "@/pages/Dispatch";
import HRBackOffice from "@/pages/HRBackOffice";
import StartCompany from "@/pages/StartCompany";
import DispatchClass from "@/pages/DispatchClass";
import SafetyAudit from "@/pages/SafetyAudit";
import AboutAmanda from "@/pages/AboutAmanda";
import EliteMentorship from "@/pages/EliteMentorship";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <ScrollProgress />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <MobileCTA />
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Loader />
          <ScrollTop />
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/dispatch" element={<SiteLayout><Dispatch /></SiteLayout>} />
            <Route path="/hr-back-office" element={<SiteLayout><HRBackOffice /></SiteLayout>} />
            <Route path="/start-a-trucking-company" element={<SiteLayout><StartCompany /></SiteLayout>} />
            <Route path="/dispatch-class" element={<SiteLayout><DispatchClass /></SiteLayout>} />
            <Route path="/safety-audit" element={<SiteLayout><SafetyAudit /></SiteLayout>} />
            <Route path="/elite-mentorship" element={<SiteLayout><EliteMentorship /></SiteLayout>} />
            <Route path="/about-amanda" element={<SiteLayout><AboutAmanda /></SiteLayout>} />
            <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
